import { motion } from "framer-motion";
import { EASE } from "../../lib/site";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const LINE = { hidden: { y: "110%" }, show: { y: "0%" } };

export const MaskLine = ({ children, delay = 0, className = "", inView = false }) => {
  const props = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className="-mt-[0.14em] block overflow-hidden pb-[0.06em] pt-[0.14em]" initial="hidden" {...props}>
      <motion.span
        className={`block ${className}`}
        variants={LINE}
        transition={{ duration: 1.1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const Eyebrow = ({ children, index, dark = false }) => (
  <div className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] ${dark ? "text-[#0a0a0c]" : "text-[var(--red)]"}`}>
    {index && <span className={dark ? "text-[#0a0a0c]/70" : "text-zinc-400"}>{index}</span>}
    <span className={`h-px w-8 ${dark ? "bg-[#0a0a0c]" : "bg-[var(--red)]"}`} />
    <span>{children}</span>
  </div>
);

export const Logo = ({ className = "h-9 w-auto" }) => (
  <img src="/img/logo-mark.png" alt="" aria-hidden="true" className={className} />
);
